var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',[_c('h3',{staticClass:"text-center"},[_vm._v("Customer Sources")]),_vm._v(" "),(_vm.loading === false)?_c('section',{staticStyle:{"display":"flex","justify-content":"center"}},[_c('Bar',{attrs:{"options":_vm.chartOptions,"data":_vm.chartData}})],1):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }